<template lang="pug">
  div(v-if="opened")
    transition
      div(
        style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, 28%);"
      ).small-modal.open
        div
          div.modal
            div.modal_container
              div.body-wrapper
                e-form(:formValidator="formValidator")
                  div.body
                    div.col

                      e-form-group(
                        label="Населенный пункт"
                        name="location"
                        inputType="select"
                        :options="msnsByLocations"
                        :model="fields"
                        tabView="tab1"
                        :required="true"
                      )

                      e-form-group(
                        name="startAddress"
                        inputType="address"
                        label="Начальная точка"
                        :model="fields"
                        tabView="tab1"
                        :required="true"
                        :addressData="addressData"
                        @selectItem="onSelectAddress"
                      )

                      e-form-group(
                        name="tkoObjectId"
                        inputType="select"
                        label="Место размещения отхода"
                        :model="fields"
                        tabView="tab1"
                        :required="true"
                        :options="tkoObjects"
                        @change="onChangeAddressTkoObject"
                      )

                      e-form-group(
                        name="routeVolume"
                        inputType="input"
                        label="Максимальный объем рейса"
                        :model="fields"
                        tabView="tab1"
                        :required="true"
                        validationRule="double"
                      )

                      e-form-group(
                        name="includeAdditionalPoints"
                        :model="fields"
                        tabView="tab1"
                        caption="Дополнительные точки"
                        inputType="checkbox"
                      )

              div.footer
                div.actions-filter-panel.actions-filter-panel--right
                  div
                    button(type="button" @click="close()").actions-filter-panel__button.standart.standart-noborder Отмена
                    template(v-if="freezed")
                      button(v-if="userCanCreate" type="button" @click="").actions-filter-panel__button.standart Формирование...
                    template(v-else)
                      button(v-if="userCanCreate" type="button" @click="sendForm()").actions-filter-panel__button.standart Сформировать
</template>

<script>
  import formBaseMixin from '../../../components/form/form-base-mixin.js'
  import Route from '../models/Route.js'
  import {prepareMSNModel} from "../utils/transformers"

  export default {
    name: 'auto-route',
    mixins: [formBaseMixin],
    title: false,
    data () {
      return {
        opened: false,
        freezed: true,
        locationItems: [],
        addressData: {},
        fields: {
          location: '',
          count: '',
          routeVolume: '',
          startAddress: '',
          startPoint: {
            coords: [],
            address: '',
            data: null
          },
          tkoObjectId: '',
          includeAdditionalPoints: false,
          endAddress: '',
          endPoint: {
            id: null,
            coords: [],
            address: '',
            data: null
          }
        }
      }
    },
    props: {
      msnsByLocations: {
        type: Array,
        default: () => []
      },
      tkoObjects: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      onChangeAddressTkoObject () {
        this.tkoObjects.forEach(item => {
          if (item.id === this.fields.tkoObjectId) {
            this.fields.endPoint = {}
            this.fields.endPoint.coords = [
              +item.latitude,
              +item.longitude
            ]
            this.fields.endPoint.id = item.id
            this.fields.endPoint.address = item.name
            this.fields.endAddress = `${item.name}, ${item.address}`
          }
        })
      },
      onSelectAddress ({data, value}) {
        this.fields.startAddress = value
        this.fields.startPoint = {}
        this.fields.startPoint.coords = [
          +data.geo_lat,
          +data.geo_lon
        ]
        this.fields.startPoint.address = value
        this.fields.startPoint.data = data
      },
      getMSNofSelectedLocation () {
        // get route count
        let index = this.msnsByLocations.findIndex(v => v.id == this.fields.location)
        let locationItems = this.msnsByLocations[index].items.slice().map(prepareMSNModel)
        let filteredItems = []
        // если галка доп - добавялем все дполнительые тчоки
        if (this.fields.includeAdditionalPoints) {
          //TODO проверить как только эти точки появятся в БД
          locationItems.forEach(msn => {
            if (+msn.msn_type_id === 2) {
              filteredItems.push(msn)
            }
          })
        }
        if(filteredItems.length > 0) {
          locationItems = {locationItems, ...filteredItems}
        }
        return [...new Set(locationItems)]
      },
      additionalValidate: async function (hasError = false, errors = {}) {
        let hasStartAdr = this.fields.startPoint && this.fields.startPoint.coords[0]
        if (!hasStartAdr) {
          if (this.fields.startAddress) {
            errors['startAddress'] = 'Координаты не удалось определить, укажите другой адрес'
          } else {
            errors['startAddress'] = 'Укажите адрес гаража'
          }
        }
        let hasEndAdr = this.fields.endPoint && this.fields.endPoint.coords[0]
        if (!hasEndAdr) {
          errors['tkoObjectId'] = 'Конечная точка не указана или не имеет координат'
        }
        let items = this.getMSNofSelectedLocation()
        if (items.length > 0) {
          let maxVolume = items.reduce((prevMaxVal, msn) => msn.volume_count > prevMaxVal
            ? msn.volume_count
            : prevMaxVal, items[0].volume_count || 0)
          if (maxVolume > this.fields.routeVolume) {
            errors['routeVolume'] = `Объем не может быть меньше контейнера максимального размера: ${maxVolume}`
          }
        } else {
          errors['location'] = 'У выбранного города нет мусорных контейнеров подходящих по условиям'
        }

        if (Object.keys(errors).length > 0) {
          this.formValidator.handleServerErrors({
            data: {errors}
          })
          return Promise.reject(false)
        }
        return Promise.resolve(1)
      },
      saveForm () {
        if (this.freezed) {
          return
        }
        const items = this.getMSNofSelectedLocation()
        let chunkSize = 20
        let parts = []
        for(let i = 0, c = items.length; i <= c; i += chunkSize){
          let chunk = items.slice(i,  i + chunkSize)
          if(chunk){
            parts.push(chunk)
          }
        }
        const routes = []
        parts.forEach(part => {
          let accumulatedVolume = 0
          let msnForAdd = []
          for (let i = 0; i < part.length; i++) {
            let msn = part[i]
            // create routes
            let nextVal = accumulatedVolume + +msn.volume_count
            if (nextVal > this.fields.routeVolume) {
              accumulatedVolume = 0
              let route = new Route(this.fields.startPoint, this.fields.endPoint)
              route.msn = msnForAdd.slice()
              routes.push(route)
              msnForAdd = []
            }
            accumulatedVolume = accumulatedVolume + msn.volume_count
            msnForAdd.push(msn)
          }
          if (msnForAdd.length > 0) {
            let route = new Route(this.fields.startPoint, this.fields.endPoint)
            route.msn = msnForAdd.slice()
            routes.push(route)
          }
          // double check
          routes.forEach(route => {
            let sum = route.msn.reduce((prev, {volume_count}) => prev + volume_count, 0)
            if (sum > this.fields.routeVolume) {
              throw new Error('Не удалось сформировать маршруты, попробуйте изменить Максимальный объем рейса')
            }
          })
        })
        if (routes.length === 0) {
          throw new Error('Нет контейнеров подходящих под условия')
        }
        this.$emit('routesGenerated', routes)
      },
      freeze () {
        this.freezed = true
      },
      open () {
        this.opened = true
        this.freezed = false
      },
      close () {
        this.opened = false
        this.freezed = true
        this.fields = Object.assign({}, {
          location: '',
          count: ''
        })
      }
    }
  }
</script>
